import { withInstall } from '@ll-plus/utils'

import Slider from './src/slider.vue'

export const LlSlider = withInstall(Slider)
export default LlSlider
export * from './src/slider'

declare module 'vue' {
  export interface GlobalComponents {
    LlSlider: typeof Slider
  }
}
